export const getWebsiteRegion = (state) => {
  const {
    appGlobal: {
      region: { region },
    },
  } = state;
  return region;
};
